//-------------------------------------------------------------------------------------------------

type AdImageViewerProps = {
  sourceUrl?: string | null;
};

export default function AdImageViewer({ sourceUrl }: AdImageViewerProps) {
  if (!sourceUrl || sourceUrl === "N/A") {
    return null;
  }

  return (
    <img
      style={{
        objectFit: "contain",
        width: "100%",
        height: "100%",
      }}
      src={sourceUrl}
      alt="Ad-image"
    />
  );
}
